import React from 'react'
import { Checkbox } from 'antd'
import PropTypes from 'prop-types'

const ChecCheckbox = ({
  disabled,
  checked,
  onChange,
  indeterminate,
  children,
  group,
  name,
  defaultValue,
  value,
  options,
  className,
}) =>
  group ? (
    <Checkbox.Group
      className={className}
      onChange={onChange}
      name={name}
      value={value}
      defaultValue={defaultValue}
      options={options}
    />
  ) : (
    <Checkbox
      className={className}
      indeterminate={indeterminate}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      name={name}
      value={value}
    >
      {children}
    </Checkbox>
  )

ChecCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  group: PropTypes.bool,
  indeterminate: PropTypes.bool,

  onChange: PropTypes.func,

  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  // TODO: define options as arrayOf(PropTypes.shape({ ... shape }))
  options: PropTypes.array,

  name: PropTypes.string,
  className: PropTypes.string,

  defaultValue: PropTypes.any,
  value: PropTypes.any,
}

export default ChecCheckbox
